import { actionTypes } from "../contants/actionTypes";

const initialState = {
    filters: {}
}

export const chartsReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'Filter [Charts]':
            return {
                ...state,
                filters: action.payload,
            }
        default:
            return state;
    }
}